/**
 * @file 用户user 模块接口列表
 * @version
 * @author pankzou
 * @date 2021-10-08
 * @lastModified
 * @lastModifiedDate
 */

import { post, postQuery } from "../http"

export default {
    // md5加密
    findDgsLicList(data) {
        return post('/api/publicNotice/encryptParams', data)
    },
    // 查询
    licmaininfo(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/LIC_MAIN_INFO_SJC_001_CS', data, { ...headers })
    },
    // 查询
    xzfAllNum(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/LIC_MAIN_INFO_XZF_NUM', data, { ...headers })
    },
    // 按需查询
    licmaininfobyparam(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/LIC_MAIN_INFO_SJC_001_TJ', data, { ...headers })
    },
    licmaininfobygy(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/licmaininfobygy', data, { ...headers })
    },
    licmaininfobygyparam(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/licmaininfobygyparam', data, { ...headers })
    },
    // 查询广告的详情
    ggspXzspFile(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/GGSP_XZSP_File', data, { ...headers })
    },
    // 小作坊全量查询
    xcyAllQuery(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/LIC_MAIN_INFO_XZF_CS', data, { ...headers })
    },
    // 小餐饮条件查询
    xcyParamQuery(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH//LIC_MAIN_INFO_XZF_TJ', data, { ...headers })
    }
}
